import React, { useState, useEffect } from 'react';
import {  io,Socket } from 'socket.io-client';
import {motion} from 'framer-motion';
import { Button, Input, Upload } from 'antd';
import { CiCircleFilled, CopyFilled, CreditCardFilled, EyeFilled, FileExclamationFilled, FileImageOutlined, LaptopOutlined, LogoutOutlined } from '@ant-design/icons';
import useMessage from 'antd/es/message/useMessage';

const {TextArea} = Input;
interface Message {
  content: string;
  fileName?: string;
  fileData?: string;
}

const copyToClipboard = async (text:string) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err:any) {
    console.error('Failed to copy: ', err);
    throw new Error(`Failed to copy : ${err.message}`);
  }
};

const App: React.FC = () => {


  const [messageAPI, contextHolder] = useMessage();

  const [connected, setConnected] = useState(false);
  const [showRoomId, setRoomIdVisibility] = useState(false);
  const [roomId, setRoomId] = useState<string>('');
  const [inputRoomId, setInputRoomId] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [receivedMessages, setReceivedMessages] = useState<Message[]>([]);
  const [socket, setSocket] = useState<Socket | null>(null);

  useEffect(() => {
    // Load roomId from localStorage
    const savedRoomId = localStorage.getItem('roomId');
    if (savedRoomId) {
      setRoomId(savedRoomId);
    }
  }, []);

  useEffect(() => {
    if (roomId) {
      // Connect to Socket.IO
      const newSocket = io();
      setSocket(newSocket);

      newSocket.on('connect', () => {
        setConnected(true);
        newSocket.emit('join', roomId);
      });

      newSocket.on('message', (data: Message) => {
        setReceivedMessages((prev) => [...prev, data]);
      });

      newSocket.on('disconnect', () => {
        setConnected(false);
      });

      return () => {
        newSocket.disconnect();
      };
    }
  }, [roomId]);

  const generateRoomId = () => {
    const newRoomId = Math.random().toString(36).substr(2, 15);
    setRoomId(newRoomId);
    localStorage.setItem('roomId', newRoomId);
  };

  const joinRoom = () => {
    setRoomId(inputRoomId);
    localStorage.setItem('roomId', inputRoomId);
  };

  const sendMessage = () => {
    if (socket && connected) {
      const data: Message = { content: message };
      socket.emit('message', data);
      setReceivedMessages((prev) => [...prev, data]);
      setMessage('');
    }
  };

  const handleFileUpload = (file:File) => {
    if (file && socket && connected) {
      const reader = new FileReader();
      reader.onload = () => {
        const fileData = reader.result as string;
        const data: Message = {
          content: '',
          fileName: file.name,
          fileData,
        };
        socket.emit('message', data);
        setReceivedMessages((prev) => [...prev, data]);
      };
      reader.readAsDataURL(file);
    }
  };

  return (<>
  {contextHolder}
  <div style={{textAlign:'center', padding:10, fontFamily:'monospace', fontSize:18, fontWeight:'bold', color:'white', backgroundColor:'black'}}>
<CreditCardFilled/> LiveShare Socket
  </div>
    <div style={{display:'flex', alignItems:'center', flexDirection:'column', justifyContent:'center'}}>
      {!roomId ? (
        <div>
          <Button style={{margin:10}} type='primary' onClick={generateRoomId}>Generate Room ID</Button>
            <Button style={{margin:10}} type='primary' onClick={joinRoom}>Join Room</Button>
          <div>
            <Input
              type="text"
              placeholder="Enter Room ID"
              value={inputRoomId}
              onChange={(e) => setInputRoomId(e.target.value)}
            />
          </div>
        </div>
      ) : (
        <div>
          <p style={{fontFamily:"monospace"}}>Your Room ID: {showRoomId?roomId:roomId.split("").map(i=>"*").join("")} 
            <Button onMouseLeave={()=>{setRoomIdVisibility(false);}}  onMouseEnter={()=>{setRoomIdVisibility(true)}}><EyeFilled/></Button>
          <Button onClick={()=>{setRoomId(''); window.localStorage.removeItem('roomId')}} style={{marginLeft:20}}>Leave <LogoutOutlined style={{marginLeft:20}}/></Button>
          </p>
          <div>
            <TextArea
            placeholder='Copy Paste text 👇 here and get it 👉 There...'
              rows={4}
              cols={50}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></TextArea>
            <Button style={{margin:10}} type='primary' onClick={sendMessage}>Send</Button>
          </div>
          <div>
            <Upload showUploadList={false}  beforeUpload={(file) => {
    handleFileUpload(file);
    return false; // Prevent default upload behavior
  }}   >
            <Button><FileImageOutlined/> SEND A FILE</Button>
              </Upload>
          </div>
          <div>
            <h3>Received Messages and Files:</h3>
            <ul>
              {receivedMessages.map((msg, idx) => (
                <li key={idx}>
                  {msg.content && <motion.div animate={{scale:1, opacity:1}} initial={{scale:0, opacity:0}}  style={{position:'relative', margin:5}}><Button onClick={()=>{copyToClipboard(msg.content).then(()=>{messageAPI.success('Text Copied')}).catch(err=>{messageAPI.error(err.message);})}} title='COPY' style={{position:'absolute', top:5, right:5, zIndex:100 }} type='primary' ><CopyFilled/></Button><TextArea spellCheck={false}  style={{resize:'none', height:100, color:'black', backgroundColor:'white'}} value={msg.content}></TextArea></motion.div>}
                  {msg.fileName && (
                    <motion.div animate={{scale:1, opacity:1}} initial={{scale:0, opacity:0}} style={{padding:5, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', margin:5, borderRadius:10, backgroundColor:'#0066db', color:'white'}}>
                      <p><FileExclamationFilled/> {msg.fileName}</p>
                      <a href={msg.fileData} download={msg.fileName}>
                        <Button>Click to Download</Button>
                      </a>
                    </motion.div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
<br></br><br></br><br></br><br></br>
    <div style={{textAlign:'center', position:'fixed', bottom:0, width:'100%', padding:10, fontFamily:'monospace', fontSize:18, fontWeight:'bold', color:'white', backgroundColor:'black'}}>
<LaptopOutlined/> Developed by SarbZone
  </div>
    </>);
};

export default App;